"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SmartRivers_exports = {};
__export(SmartRivers_exports, {
  StSmartRivers: () => StSmartRivers
});
module.exports = __toCommonJS(SmartRivers_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const marker1 = import_topo_map.marker.fromColor("#891200");
const marker2 = import_topo_map.marker.fromColor("#c62c2c");
const marker3 = import_topo_map.marker.fromColor("#d57025");
const marker4 = import_topo_map.marker.fromColor("#e5aa16");
const marker5 = import_topo_map.marker.fromColor("#8dba38");
const StSmartRivers = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("StSmartRivers"),
  title: "SmartRivers",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("StSmartRivers"),
      title: "SmartRivers",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("StSmartRivers"),
        attribution: []
      }),
      defaultAttribute: "psi",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Time and Location",
          attributes: [
            (0, import_topo_map.stringAttr)({
              attributeId: "catchment",
              label: "Catchment",
              showDistribution: false,
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "river",
              label: "River",
              showDistribution: false,
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "site",
              label: "Site",
              showDistribution: false,
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "trpiRiverType",
              label: "TRPI River Type",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              label: "Season",
              attributeId: "season",
              buckets: [
                (0, import_topo_map.lookupBucket)("Spring", import_topo_map.marker.fromColor("lime")),
                (0, import_topo_map.lookupBucket)("Autumn", import_topo_map.marker.fromColor("orange"))
              ]
            }),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            }),
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs")
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Calculations",
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "psi",
              label: "PSI (Sedimentation Pressure)",
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 20, marker1, "Heavily Sedimented"),
                (0, import_topo_map.rangeBucket)(21, 40, marker2, "Sedimented"),
                (0, import_topo_map.rangeBucket)(41, 60, marker3, "Moderately Sedimented"),
                (0, import_topo_map.rangeBucket)(61, 80, marker4, "Slightly Sedimented"),
                (0, import_topo_map.rangeBucket)(81, 100, marker5, "Naturally/Unsedimented")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "trpi",
              label: "TRPI (Phosphorus Enrichment Pressure)",
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 20, marker1, "Very high"),
                (0, import_topo_map.rangeBucket)(21, 40, marker2, "High"),
                (0, import_topo_map.rangeBucket)(41, 60, marker3, "Moderate"),
                (0, import_topo_map.rangeBucket)(61, 80, marker4, "Low"),
                (0, import_topo_map.rangeBucket)(81, 100, marker5, "Very low")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "spear",
              label: "SPEAR (Chemical Pressure)",
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 11, marker1, "Bad (Heavily Impacted)"),
                (0, import_topo_map.rangeBucket)(11, 22, marker2, "Poor"),
                (0, import_topo_map.rangeBucket)(22, 33, marker3, "Moderate"),
                (0, import_topo_map.rangeBucket)(33, 44, marker4, "Good"),
                (0, import_topo_map.rangeBucket)(44, 100, marker5, "High (Unimpacted)")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "si",
              label: "Saprobic (Organic Enrichment Pressure)",
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 1.8, marker5, "Minimal Organic Loading"),
                (0, import_topo_map.rangeBucket)(1.8, 2.3, marker4, "Mild Organic Loading"),
                (0, import_topo_map.rangeBucket)(2.3, 2.7, marker3, "Moderate Organic Loading"),
                (0, import_topo_map.rangeBucket)(2.7, 3.2, marker2, "Strong Organic Loading"),
                (0, import_topo_map.rangeBucket)(3.2, 4, marker1, "Extreme Organic Loading")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "life",
              label: "LIFE (Flow Related Pressure)",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 6, marker1, "Heavily Impacted"),
                (0, import_topo_map.rangeBucket)(6, 6.5, marker2, "Impacted"),
                (0, import_topo_map.rangeBucket)(6.5, 7, marker3, "Moderately Impacted"),
                (0, import_topo_map.rangeBucket)(7, 8, marker4, "Slightly Impacted"),
                (0, import_topo_map.rangeBucket)(8, null, marker5, "Unimpacted")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "bmwp",
              label: "BMWP",
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 13, marker5, "Heavily Impacted"),
                (0, import_topo_map.rangeBucket)(13, 36, marker4, "Impacted"),
                (0, import_topo_map.rangeBucket)(36, 51, marker3, "Moderately Impacted"),
                (0, import_topo_map.rangeBucket)(51, 71, marker2, "Slightly Impacted"),
                (0, import_topo_map.rangeBucket)(71, null, marker1, "Unimpacted")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "cci",
              label: "CCI",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "aspt",
              label: "ASPT",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "ntaxa",
              label: "NTAXA",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "eptSp",
              label: "EPT sp (taxa)",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "eptAb",
              label: "EPT ab",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "totalAb",
              label: "TOTAL ab",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "totalSpecies",
              label: "TOTAL sp",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "whpt",
              label: "WHPT",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "whptAspt",
              label: "WHPT ASPT",
              showDistribution: false,
              showTimeline: false,
              buckets: "auto"
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StSmartRivers
});
//# sourceMappingURL=SmartRivers.js.map
